<template>
  <div class="container-fluid py-4">
    <!-- 기존 코드 -->
    <div class="row">
      <div class="col-12">
        <div class="card my-4">
          <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
            <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
              <div class="d-flex justify-content-between align-items-center flex-wrap px-3">
                <h6 class="text-white text-capitalize">선생님 리스트</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <select v-model="filters.department" @change="fetchGrades()" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="">부서 선택</option>
                    <option v-for="department in departments" :key="department.id" :value="department.id">
                      {{ department.name }}
                    </option>
                  </select>
                  <input
                    v-model="filters.name"
                    type="text"
                    class="form-control me-2 searchInput"
                    placeholder="이름 검색"
                  />
                  <input
                    v-model="filters.phone"
                    type="text"
                    class="form-control me-2 searchInput"
                    placeholder="연락처 검색"
                  />
                  <select v-model="filters.withdrawal" class="form-select me-2 searchInput" style="width: fit-content; padding-left: 5px; padding-right: 15px;">
                    <option value="exclude">삭제 제외</option>
                    <option value="include">삭제 포함</option>
                  </select>
                  <button class="btn btn-light text-success me-2 mt-2 mt-sm-0" @click="fetchteachers(1)">검색</button>
                  <button class="btn btn-light text-success mt-2 mt-sm-0" @click="exportTeachersExcel">다운로드</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body px-0 pb-2 justify-content-center">
  <div class="table-responsive p-0">
    <table class="table mb-0">
      <thead>
        <tr class="text-center">
          <th class="text-center">번호</th>
          <th class="text-center">사진</th>
          <th class="text-center">이름</th>
          <th class="text-center">반</th>
          <th class="text-center">연락처</th>
          <th class="text-center">등록일</th>
        </tr>
      </thead>
      <tbody id="memberlist_table">
        <tr v-if="teachers.length === 0">
          <td colspan="9" class="text-center">조회된 자료가 없습니다</td>
        </tr>
        <tr v-for="(student, index) in teachers" :key="student.no" class="text-center">
          <td class="text-center">
            <p>{{ (index + 1) + ((currentPage - 1) * 20) }}</p>
          </td>
          <td class="text-center">
            <img
              :src="student.photo 
                      ? `https://manna.dongan1718.com/upload/photo/${student.photo}` 
                      : student.photo2 
                      ? `https://manna.dongan1718.com/upload/photo/${student.photo2}` 
                      : require('@/assets/img/noimage.png')"
              class="avatar me-3 border-radius-lg"
              alt="photo"
            />
          </td>
          <td class="text-center name" style="font-weight: bold; color: #0b62ff; cursor: pointer" @click="openPopup(student)">
            <p>{{ student.name }}</p>
          </td>
          <td class="text-center">
            <p>{{ student.gradename }}</p>
          </td>
          <td class="text-center">
            <p>{{ student.phone }}</p>
          </td>
          <td class="text-center">
            <p>{{ student.createdt }}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- 변경된 Pagination -->
  <div class="d-flex justify-content-center mt-4">
    <material-pagination>
      <material-pagination-item prev @click="fetchteachers(currentPage - 1)" :disabled="currentPage === 1" />
      <material-pagination-item
        v-for="page in totalPages"
        :key="page"
        :label="page"
        :active="currentPage === page"
        @click="fetchteachers(page)"
      />
      <material-pagination-item next @click="fetchteachers(currentPage + 1)" :disabled="currentPage === totalPages" />
    </material-pagination>
  </div>
</div>

        </div>
      </div>
    </div>

    <!-- Popup Modal -->
    <!-- Edit Modal -->
    <div v-if="showPopup" class="popup-overlay">
      <div class="popup-content">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="m-0">선생님 정보 수정</h5>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">이름</label>
            <input class="form-control" v-model="editForm.name" readonly />
          </div>
          <div class="col-md-6">
            <label class="form-label">연락처</label>
            <input class="form-control" v-model="editForm.phone" readonly />
          </div>
          <div class="col-md-6">
            <label class="form-label">부서</label>
            <select class="form-select" v-model="editForm.classid" @change="onEditDeptChange">
              <option value="">선택</option>
              <option v-for="d in departments" :key="d.id" :value="d.id">{{ d.name }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">반</label>
            <select class="form-select" v-model="editForm.grade" @change="onEditGradeChange">
              <option value="">선택</option>
              <option v-for="g in editGrades" :key="g.grade" :value="g.grade">{{ g.gradename }}</option>
            </select>
          </div>
          <div class="col-12 d-flex justify-content-end mt-2">
            <button v-if="editForm.useyn !== 'N'" class="btn btn-outline-danger me-2" @click="deleteTeacher">삭제</button>
            <button v-else class="btn btn-outline-warning me-2" @click="restoreTeacher">복구</button>
            <button class="btn btn-secondary me-2" @click="closePopup">닫기</button>
            <button class="btn btn-success" @click="saveTeacher">저장</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiservice from "../services/apiservice";
import { saveAs } from 'file-saver';
import MaterialPagination from "@/components/MaterialPagination.vue";
//import MaterialPaginationItem from "@/components/MaterialPaginationItem.vue";

export default {
  name: "tables",
  components: { MaterialPagination },
  data() {
    return {
      teachers: [],
      currentPage: 1,
      totalPages: 1,
      filters: {
        classid: "",
        name: "",
        phone: "",
        school: "",
        grade: "",
        department: "",
        withdrawal: "exclude",
      },
      userData: "",
      showPopup: false,
      selectedStudent: {},
      editForm: { id: null, classid: '', grade: '', name: '', phone: '', role: 3, useyn: 'Y' },
      departments: [],
      grades: [],
      editGrades: [],
    };
  },
  methods: {
    async fetchteachers(page = 1) {
      if (!this.filters.department) {
        // If no department is selected, do not perform the search
        return;
      }
      console.log(this.filters);
      try {
        const response = await apiservice.teacherlist({
          params: { page, ...this.filters },
        });
        if (response.data && response.data.data) {
          this.teachers = response.data.data;
          this.currentPage = response.data.currentPage;
          this.totalPages = response.data.totalPages;
          console.log("Fetched teachers:", this.teachers);
        } else {
          console.error("Unexpected response format:", response);
        }
      } catch (error) {
        console.error("Failed to fetch teachers:", error);
      }
    },
    async exportTeachersExcel() {
      try {
        if (!this.filters.department) {
          alert('부서를 선택해주세요.');
          return;
        }
        const params = {
          page: 1,
          limit: 10000,
          department: this.filters.department,
          withdrawal: 'exclude', // useyn='Y'
          name: this.filters.name || '',
          phone: this.filters.phone || ''
        };
        const response = await apiservice.teacherlist({ params });
        const rows = (response.data && response.data.data) ? response.data.data : [];

        const headers = [
          { key: 'id', label: 'id', desc: 'ID', color: '#D9D9D9' },
          { key: 'classid', label: 'classid', desc: '부서코드', color: '#D9D9D9' },
          { key: 'teacherid', label: 'teacherid', desc: '선생님코드', color: '#D9D9D9' },
          { key: 'grade', label: 'grade', desc: '반', color: '#D9D9D9' },
          { key: 'role', label: 'role', desc: '권한', color: '#D9D9D9' },
          { key: 'name', label: 'name', desc: '이름', color: '#D9D9D9' },
          { key: 'phone', label: 'phone', desc: '휴대폰번호', color: '#D9D9D9' },
        ];

        const escapeHtml = (s) => String(s || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');

        let html = '<html><head><meta charset="UTF-8"></head><body>';
        html += '<table border="1" cellspacing="0" cellpadding="5">';
        // header row (gray)
        html += '<tr>';
        headers.forEach(h => { html += `<th style="background:${h.color};font-weight:bold;">${h.label}</th>`; });
        html += '</tr>';
        // description row (gray as well)
        html += '<tr>';
        headers.forEach(h => { html += `<th style="background:${h.color};font-weight:bold;">${h.desc}</th>`; });
        html += '</tr>';
        rows.forEach(r => {
          html += '<tr>';
          headers.forEach(h => { html += `<td>${escapeHtml(r[h.key])}</td>`; });
          html += '</tr>';
        });
        html += '</table></body></html>';

        const blob = new Blob(["\uFEFF" + html], { type: 'application/vnd.ms-excel;charset=utf-8' });
        const deptName = (this.departments.find(d => d.id === this.filters.department)?.name) || '부서';
        const today = new Date().toISOString().split('T')[0];
        saveAs(blob, `선생님리스트_${deptName}_${today}.xls`);
      } catch (e) {
        console.error('다운로드 오류:', e);
        alert('다운로드 중 오류가 발생했습니다.');
      }
    },
    openPopup(student) {
      this.selectedStudent = { ...student };
      this.editForm = {
        id: student.id,
        classid: student.classid || '',
        grade: student.grade || '',
        name: student.name || '',
        phone: student.phone || '',
        role: student.role || (student.gradename === '선생님' ? 5 : 3),
        useyn: student.useyn || 'Y'
      };
      this.showPopup = true;
      this.onEditDeptChange();
    },
    closePopup() {
      this.showPopup = false;
      this.selectedStudent = {};
    },
    async handleSave(updatedStudent) {
      try {
        await apiservice.updateStudent(updatedStudent);
        alert("수정 완료");
        this.closePopup();
        this.fetchteachers();
      } catch (error) {
        console.error("Error updating student:", error);
        alert("수정 중 오류 발생");
      }
    },
    async fetchGroups() {
      if (!this.filters.classid) return;
      try {
        const response = await apiservice.getGrade({
          params: { classid: this.filters.classid },
        });
        this.grade = response.data.data;
      } catch (error) {
        console.error("Failed to fetch groups:", error);
      }
    },
    async fetchDepartments() {
      try {
        const response = await apiservice.getDepartments();
        this.departments = response.data.data;
      } catch (error) {
        console.error("Failed to fetch departments:", error);
      }
    },
    async fetchGrades() {
      if (!this.filters.department) return;
      try {        
        const response = await apiservice.getclasslist({ classid: this.filters.department });
        this.grades = response.data.data.map(grade => ({
          id: grade.grade,
          name: grade.gradename
        }));
      } catch (error) {
        console.error("Failed to fetch grades:", error);
      }
    },
    async onEditDeptChange() {
      if (!this.editForm.classid) {
        this.editGrades = [];
        return;
      }
      try {
        const resp = await apiservice.get_grades_by_dept({ classid: this.editForm.classid });
        this.editGrades = (resp.data && resp.data.data) ? resp.data.data.map(r => ({ grade: r.grade, gradename: r.gradename })) : [];
        if (!this.editGrades.find(g => g.grade === this.editForm.grade)) {
          this.editForm.grade = '';
        }
      } catch (e) {
        this.editGrades = [];
      }
    },
    onEditGradeChange() {
      const found = this.editGrades.find(g => g.grade === this.editForm.grade);
      const label = found ? found.gradename : '';
      this.editForm.role = (label === '선생님') ? 5 : 3;
    },
    async saveTeacher() {
      try {
        const payload = {
          id: this.editForm.id,
          classid: this.editForm.classid || '',
          grade: this.editForm.grade || '',
          role: this.editForm.role
        };
        const resp = await apiservice.update_teacher(payload);
        if (resp.data && resp.data.success) {
          alert('저장되었습니다.');
          this.showPopup = false;
          this.fetchteachers(this.currentPage);
        } else {
          alert('저장 실패');
        }
      } catch (e) {
        console.error(e);
        alert('저장 중 오류가 발생했습니다.');
      }
    },
    async deleteTeacher() {
      if (!confirm('정말 삭제하시겠습니까? (useyn = N)')) return;
      try {
        const resp = await apiservice.update_teacher({ id: this.editForm.id, useyn: 'N' });
        if (resp.data && resp.data.success) {
          alert('삭제되었습니다.');
          this.showPopup = false;
          this.fetchteachers(this.currentPage);
        } else {
          alert('삭제 실패');
        }
      } catch (e) {
        console.error(e);
        alert('삭제 중 오류가 발생했습니다.');
      }
    },
    async restoreTeacher() {
      if (!confirm('이 선생님을 복구하시겠습니까? (useyn = Y)')) return;
      try {
        const resp = await apiservice.update_teacher({ id: this.editForm.id, useyn: 'Y' });
        if (resp.data && resp.data.success) {
          alert('복구되었습니다.');
          this.showPopup = false;
          this.fetchteachers(this.currentPage);
        } else {
          alert('복구 실패');
        }
      } catch (e) {
        console.error(e);
        alert('복구 중 오류가 발생했습니다.');
      }
    },
  },
  // watch: {
  //   "filters.classid"() {
  //     this.fetchGroups();
  //   },
  // },
  async created() {
    try {
      const response = await apiservice.getdeptlist();
      this.departments = response.data.data.map(department => ({
        id: department.code,
        name: department.codename
      }));
    } catch (error) {
      console.error("Failed to fetch department list:", error);
    }
    this.fetchGroups();
    //this.fetchteachers();
  },
};
</script>
<style scoped>
.d-flex.align-items-center {
  align-items: center;
}

.searchInput {
  text-align: center;
  width: 150px;
  background-color: white !important;
  margin-bottom: 0;
}

.btn {
  margin-bottom: 0;
}

.card-header, .card-body, .pagination {
  padding: 10px;
}

/* 반응형 스타일 */
@media (max-width: 768px) {
  .d-flex {
    flex-direction: column;
    align-items: stretch;
  }
  .form-select, .form-control {
    width: 100% !important;
    margin-bottom: 10px;
  }
  .searchInput {
    text-align: left;
  }
}
/* simple modal styles (reuse from MemberDetail if needed) */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.popup-content {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  width: 90%;
  max-width: 640px;
}
</style>
